import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-signout',
  templateUrl: './signout.component.html',
  styleUrls: ['./signout.component.css']
})
export class SignOutComponent implements OnInit {
  @Output() onModalClose = new EventEmitter();
  @Input() isSessionExpired:boolean;
constructor( private toastrService: ToastrService, private msal: MsalService) { }

ngOnInit() {
}

onHide() {
  this.onModalClose.emit("Delete");
}

ConfirmDelete() {
  this.msal.logout();
}

}

